import { Fragment } from "react";
import { NextButton, PreviousButton, StepButton } from "./UsageCarouselButton";
import { IUsageSummary } from "../interface/IUsageSummary";
import { useUsageCarousel } from "./useUsageCarousel";
import { CAROUSEL_CONFIG, sliceUsageForMobileCarrousel } from "../usageUtils";
import { ECarouselType } from "./ECarouselType";
import { CarouselItem } from "./CarouselItem";

interface IParams {
    usageSummaryList: IUsageSummary[];
    carouselType: ECarouselType;
}

export const UsageCarousel = (props: IParams) => {
    const { usageSummaryList, carouselType } = props;
    const slicedUsageSummaryList = sliceUsageForMobileCarrousel(
        usageSummaryList ?? [],
        CAROUSEL_CONFIG.MOBILE.USAGE_PER_SLIDE
    );
    const isMobileCarousel = carouselType === ECarouselType.MOBILE;
    const usageListToRender = isMobileCarousel ? slicedUsageSummaryList : usageSummaryList;

    const {
        emblaRef,
        isPrevButtonEnabled,
        isNextButtonEnabled,
        scrollNext,
        scrollPrev,
        scrollSnaps,
        selectedIndex,
        scrollTo,
    } = useUsageCarousel({
        elementsToShow: CAROUSEL_CONFIG[carouselType].ELEMENTS_TO_SHOW,
        slidesCount: usageListToRender.length,
    });

    return (
        <Fragment>
            <div className="embla">
                <div className="viewport" ref={emblaRef}>
                    <div className="container">
                        {isMobileCarousel &&
                            slicedUsageSummaryList.map((usageSummarySlice, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className="slide" data-testid="mobile-slide" key={index}>
                                    {usageSummarySlice.map((usageSummary) => (
                                        <div
                                            className="slide-content-wrapper"
                                            key={usageSummary.ratingSubtotalTypeDisplayName}
                                        >
                                            <CarouselItem usageSummary={usageSummary} />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        {!isMobileCarousel &&
                            usageSummaryList.map((usageSummary) => (
                                <div className="slide" key={usageSummary.ratingSubtotalTypeDisplayName}>
                                    <CarouselItem usageSummary={usageSummary} />
                                </div>
                            ))}
                    </div>
                </div>
            </div>
            {usageListToRender.length > CAROUSEL_CONFIG[carouselType].ELEMENTS_TO_SHOW && (
                <div className="step-button">
                    <PreviousButton isEnabled={isPrevButtonEnabled} onClick={scrollPrev} />
                    {scrollSnaps.map((_, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <StepButton isEnabled={index === selectedIndex} key={index} onClick={() => scrollTo(index)} />
                    ))}
                    <NextButton isEnabled={isNextButtonEnabled} onClick={scrollNext} />
                </div>
            )}
        </Fragment>
    );
};
